import { ACTION_GET_GATE_CONFIG, ACTION_GET_GATE_CONFIG_ERROR, ACTION_GET_GATE_CONFIG_SUCCESS } from "."
import * as api from "../../../api"

export const getGateConfigRequest = (name) => ({
    type: ACTION_GET_GATE_CONFIG,
    payload: {
        name
    }
})

export const getGateConfigSuccess = data => ({
    type: ACTION_GET_GATE_CONFIG_SUCCESS,
    payload: {
        data
    }
})


export const getGateConfigError = (msg) => ({
    type: ACTION_GET_GATE_CONFIG_ERROR,
    payload: {
        msg
    }
})

export const getGateConfig = (name) => {
    return dispatch => {
        dispatch(getGateConfigRequest())
        api.getGateConfig(name)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getGateConfigError("error"));
                    return
                }

                delete data["result"]

                dispatch(getGateConfigSuccess(data));
            }).catch((err) => {

                console.log(err)

                dispatch(getGateConfigError("system error"))
            });
    }
}